import BrowserSupport from './assets/browser-support.js';
BrowserSupport.isIE10();

import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import VueGtag from 'vue-gtag';
import './styles/app.scss';
import './styles/print.scss';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import LongformDocument from '@/pages/LongformDocument.vue';
import SearchResult from '@/pages/SearchResult.vue';
import Index from '@/pages/Index.vue';
import '@cityofphiladelphia/phila-app-css/dist/css/phila-app.min.css';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Buefy, { defaultIconPack: 'fas' });

const router = new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/page/:section',
      name: 'LongformDocument',
      component: LongformDocument,
      props: true,
    },
    {
      path: '/results/:section?',
      name: 'SearchResult',
      component: SearchResult,
      props: true,
    },
  ],
});

Vue.use(VueGtag, {
  config:{
    id: 'UA-860026-1',
    appName: 'longform-content',
    pageTrackerScreenviewEnabled: true,
    params: {},
  },
}, router);

new Vue({
  el: '#vue-app',
  router,
  render (h) {
    return h(App, {});
  },
});

Vue.mixin({
  methods: {
    philaLink( string ) {
      return string.replace(/admin.phila.gov/g, 'www.phila.gov')
        .replace(/test-admin.phila.gov/g, 'test-www.phila.gov')
        .replace(/staging-admin.phila.gov/g, 'staging-www.phila.gov');
    },
  },
});